module.exports = __webpack_public_path__ + "static/img/default_view_map.10e90196.png";